import { Extension, IExtensionConstructorParams } from "../../system/setup";

export interface ILinear {
  purpose: Extension;
}

export function initial(_params: IExtensionConstructorParams): ILinear {
  return { purpose: Extension.LINEAR };
}
